export default __webpack_public_path__ + "static/media/soil-testing.d6e30d10.jpg";